import type { CSSProperties } from 'react';
import WarningTriangleIconSvg from '../../assets/icons/warning_triangle.svg?react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const WarningTriangleIcon: React.FC<IconProps> = ({
    size = 16,
    className = '',
    style = {},
    onClick,
}) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return <WarningTriangleIconSvg className={className} style={iconStyle} onClick={onClick} />;
};

export default WarningTriangleIcon;
